<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="loading"
      :search="search"
      loading-text="Loading invitaions ..."
      no-data-text="No invitation found"
      disable-pagination
      hide-default-footer
      class="elevation-1"
    >
      <template #item.date_joined="{ item }">
        {{ toDatetime(item.date_joined) }}
      </template>
      <template v-slot:item.activation="{ item }">
        <v-btn
          class="mr-2 align-center blue white--text"
          @click="handleOpenDialog(item)"
        >
          activate
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="activationDialog"
      width="500"
      height="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Activation
          <v-spacer></v-spacer>
          <v-btn
            fab
            text
            @click="activationDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text
          class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
          align="center"
        >
          Do you want to activate the account of
          {{ selectedAccount.first_name }} {{ selectedAccount.last_name }} ?
        </v-card-text>
        <v-card-actions class="justify-center mt-10">
          <v-btn
            :style="{
              paddingLeft: '80px',
              paddingRight: '80px'
            }"
            text
            x-large
            class="mb-10 blue white--text"
            @click="confirmActivation(selectedAccount)"
          >
            Activate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdminServices from "@/services/AdminServices"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "AdminValidation",
  data() {
    return {
      headers: [
        { text: "First Name", value: "first_name", align: "start" },
        { text: "Last Name", value: "last_name" },
        { text: "Email", value: "email" },
        { text: "Company", value: "company" },
        { text: "Date joined", value: "date_joined" },
        { text: "Activate account", value: "activation", align: "center", sortable: false }
      ],
      activationDialog: false,
      users: [],
      loading: false,
      search: "",
      selectedAccount: {}
    }
  },
  methods: {
    toDatetime,
    handleOpenDialog(account) {
      this.activationDialog = true
      this.selectedAccount = account
    },
    confirmActivation(user) {
      const $ = this
      let data = {
        is_active: true
      }
      AdminServices.validateUser(this, user.id, data).then(r => {
        this.loading = true
        AdminServices.getPendingValidations($)
          .then(r => {
            this.users = r.results
          })
          .finally(() => {
            this.loading = false
          })
      })
      this.activationDialog = false
    }
  },

  mounted() {
    this.loading = true
    AdminServices.getPendingValidations(this)
      .then(r => {
        this.users = r.results
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
